import React, { useState } from 'react';

import Button from '@gjc/classi-react-commons/ClassiButton';
import Container from '@material-ui/core/Container';
import { LeadBoxFechadoWrapperDesktop } from '../LeadBox/Fechado/fechado-styled';
import Fechado from '../LeadBox/Fechado';
import DetalhesImovel from '../DetalhesImovel';
import VideoAnuncio from 'components/VideoAnuncio';
import Carrossel from 'components/Carrossel';
import CaracteristicasImovel from '../CaracteristicasImovel';
import Favoritar from 'components/Favoritar';

import { unescape } from 'lodash';
import { formatCurrency } from '../../utils/formatCurrency';

import {
    AnuncioContainer,
    AnuncioDetalhadoContainer,
    AnuncioTitulo,
    BoxFotosVideos,
    BoxInfoImovel,
    ButtonsContainer,
    DetalhesImovelBox,
    TextoCodigoAnuncio,
    TextoSetor,
} from './anuncioDetalhado-styled';

const AnuncioDetalhado = ({ anuncio }) => {
    const contentInitialState = () => {
        let isFotos = true;
        if (anuncio.urlVideo && anuncio.imagens.length == 0) {
            isFotos = false;
        }
        return isFotos;
    };

    const [isFotos, setIsFotos] = useState(contentInitialState());
    const [fav] = useState();

    const ButtonsAndTitleCondition = () => {
        if (anuncio.urlVideo && anuncio.imagens.length > 0) {
            return (
                <>
                    <ButtonsContainer>
                        <BoxFotosVideos>
                            <Button
                                label={'Fotos'}
                                appearance={'primary'}
                                type={'button'}
                                onClick={() => setIsFotos(true)}
                                style={
                                    isFotos
                                        ? {
                                              backgroundColor: '#288394',
                                              margin: 0,
                                              border: 'solid 1px #288394',
                                              width: '100%',
                                              boxShadow:
                                                  '0 0 0 0 rgba(0, 0, 0, 0)',
                                              borderRadius: 4,
                                              marginRight: 20,
                                          }
                                        : {
                                              backgroundColor: '#FFF',
                                              margin: 0,
                                              border: 'solid 1px #288394',
                                              width: '100%',
                                              boxShadow:
                                                  '0 0 0 0 rgba(0, 0, 0, 0)',
                                              color: '#288394',
                                              borderRadius: 4,
                                              marginRight: 20,
                                          }
                                }
                            />
                            <Button
                                label={'Vídeo'}
                                appearance={'primary'}
                                type={'button'}
                                onClick={() => {
                                    setIsFotos(false);
                                }}
                                style={
                                    !isFotos
                                        ? {
                                              backgroundColor: '#288394',
                                              margin: 0,
                                              border: 'solid 1px #288394',
                                              width: '100%',
                                              boxShadow:
                                                  '0 0 0 0 rgba(0, 0, 0, 0)',

                                              borderRadius: 4,
                                          }
                                        : {
                                              backgroundColor: '#FFF',
                                              margin: 0,
                                              border: 'solid 1px #288394',
                                              width: '100%',
                                              boxShadow:
                                                  '0 0 0 0 rgba(0, 0, 0, 0)',
                                              borderRadius: 4,
                                              color: '#288394',
                                          }
                                }
                            />
                        </BoxFotosVideos>
                        <Favoritar
                            idAnuncio={anuncio.id}
                            size={24}
                            favorito={fav}
                            outlineColor="#bbb"
                        />
                    </ButtonsContainer>
                    <AnuncioTitulo>{anuncio.titulo}</AnuncioTitulo>
                </>
            );
        } else {
            return (
                <AnuncioTitulo>
                    {anuncio.titulo}
                    <span style={{ marginLeft: 10 }}>
                        <Favoritar
                            idAnuncio={anuncio.id}
                            size={24}
                            favorito={fav}
                            outlineColor="#bbb"
                        />
                    </span>
                </AnuncioTitulo>
            );
        }
    };

    const mediaContentCondition = () => {
        if (anuncio.urlVideo || anuncio.imagens.length > 0) {
            return isFotos ? (
                <Carrossel anuncio={anuncio} />
            ) : (
                <VideoAnuncio anuncio={anuncio} />
            );
        }
    };

    return (
        <>
            {mediaContentCondition()}
            <Container>
                <AnuncioContainer>
                    <AnuncioDetalhadoContainer>
                        {ButtonsAndTitleCondition()}
                        <TextoSetor>{anuncio.localizacao}</TextoSetor>
                        {anuncio.codigo && (
                            <TextoCodigoAnuncio>
                                Cod. anuncio {anuncio.codigo}
                            </TextoCodigoAnuncio>
                        )}

                        {anuncio.valorCombinar ? (
                            <div className="valor">Valor a combinar </div>
                        ) : anuncio.valor ? (
                            <div className="valor">
                                {formatCurrency(anuncio.valor)}
                            </div>
                        ) : (
                            ''
                        )}

                        <h2
                            style={{
                                fontSize: '18px',
                                marginTop: '20px',
                                marginBottom: '5px',
                            }}
                        >
                            Sobre o imóvel
                        </h2>

                        <BoxInfoImovel
                            dangerouslySetInnerHTML={{
                                __html: unescape(anuncio.descricao).replace(/\n/g, '<br />'),
                            }}
                        />
                        {Boolean(
                            anuncio.areaTotal ||
                                anuncio.qtdeQuartos ||
                                anuncio.qtdeVagas ||
                                anuncio.qtdeSuites
                        ) && (
                            <>
                                <h2
                                    style={{
                                        fontSize: '18px',
                                        marginTop: '20px',
                                        marginBottom: '5px',
                                    }}
                                >
                                    Detalhes do imóvel
                                </h2>
                                <DetalhesImovelBox>
                                    <DetalhesImovel
                                        tamanhoIcon={30}
                                        areaTotal={anuncio.areaTotal}
                                        qtdeQuartos={anuncio.qtdeQuartos}
                                        qtdeSuites={anuncio.qtdeSuites}
                                        qtdeVagas={anuncio.qtdeVagas}
                                    />
                                </DetalhesImovelBox>
                            </>
                        )}
                        <CaracteristicasImovel
                            detalhesImovel={anuncio.detalhesImovel}
                            detalhesCondominio={anuncio.detalhesCondominio}
                            detalhesLazer={anuncio.detalhesLazer}
                            detalhesSeguranca={anuncio.detalhesSeguranca}
                        />
                    </AnuncioDetalhadoContainer>

                    <LeadBoxFechadoWrapperDesktop>
                        <Fechado
                            anunciante={anuncio.anunciante}
                            idAnuncio={anuncio.id}
                            tituloAnuncio={anuncio.titulo}
                        />
                    </LeadBoxFechadoWrapperDesktop>
                </AnuncioContainer>
            </Container>
        </>
    );
};

export default AnuncioDetalhado;
